/*
 * Module for the _MessageThreadDetail partial view
*/
rs.module("ui/content/communications/messagecenter/messagethreaddetail",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, cssClasses, variables, fileUpload) {

            var messagesContainer = $.js(jsSelectors.messagesContainer, { required: false });
            var printThreadButton = $.js(jsSelectors.printThreadButton, { required: false });
            var form = $.js(jsSelectors.threadForm); 

            // Detect when the selected thread's messages are in view and update the last viewed date.
            // This is necessary because on mobile, a thread's messages are not immediately in view when the page loads like on desktops.
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {

                        // Make AJAX call to update the last viewed date
                        $.post(
                            backendUrls.updateMessageLastViewedDate,
                            {
                                contactLogCrmFolderKey: variables.contactLogCrmFolderKey
                            }
                        );
                    } 
                });
            });
            if (messagesContainer.length > 0) {
                observer.observe(messagesContainer[0]);
            }
            
            // Hide the print thread button on mobile
            if ($.isMobile()) {
                printThreadButton.hide();
            }

            // Print the contents of the messagesContainer
            printThreadButton.on("click", function () {
                var printContents = $(messagesContainer).html();
                var printWindow = window.open('');
                printWindow.document.write('<html>');
                printWindow.document.write('<head>');
                printWindow.document.write('<title>Print Message Thread</title>');
                printWindow.document.write('<style>');
                printWindow.document.write('.thread-message { margin-bottom: 10px; }');
                printWindow.document.write('.message-header { font-weight: bold; }');
                printWindow.document.write('.attachment { font-style: italic; }');
                printWindow.document.write('</style>');
                printWindow.document.write('</head>');
                printWindow.document.write('<body>');
                printWindow.document.write('<h1>' + variables.threadTitle + '</h1>');
                printWindow.document.write('<hr>');
                printWindow.document.write(printContents);
                printWindow.document.write('</body>');
                printWindow.document.write('</html>');
                printWindow.document.close();
                printWindow.print();
            });

            // Dynamic textarea - changes height as user types (existing threads only)
            (function () {

                var textArea = $.js(jsSelectors.existingThreadTextArea, { required: false });

                // if we don't have the existing thread textarea (i.e. new thread) then do nothing - this is only applies to that textarea
                if (textArea.length > 0) {

                    var sendButton = $.js(jsSelectors.existingThreadSendButton, { required: false });
                    var detail = textArea.closest(".list-detail");

                    var lines = 2;
                    var lineHeight = parseInt(textArea.css("line-height"), 10);

                    // listen for input changes
                    textArea.on("input", function () {
                        sendButton.prop("disabled", textArea.val() == "");
                        resizeTextArea();
                    });

                    // listen for window resizing
                    $(window).on("resize", _.debounce(function () {
                        // when resizing, scroll position can't be accurately maintained, so we are always scrolling to the bottom
                        detail.scrollTop(detail[0].scrollHeight);
                        resizeTextArea();
                    }, 200));

                    // resize the text area based on user's inout and adjust message content accordingly
                    function resizeTextArea() {
                        // capture current scroll position before any resizing/scrolling
                        var scrollPostion = detail.scrollTop();

                        // Reset text box height to original size and set overflow to hidden
                        // This allows us to get accurate scroll heights and line counts
                        textArea.height(48);
                        textArea.css("overflow-y", "hidden");

                        var scrollHeightNoPadding = textArea[0].scrollHeight - 12;
                        var currentLines = scrollHeightNoPadding / lineHeight;

                        // Update text box height and remove overflow hidden
                        textArea.height(scrollHeightNoPadding);
                        textArea.css("overflow-y", "");

                        // If number of lines has changed, adjust message thread to match new text area height
                        // We are capping the number of lines at 5 so we want to skip doing anything after that
                        if (lines != currentLines && currentLines <= 5) {

                            // Calc number of pixels to scroll
                            var pixelsToScroll = lineHeight * (currentLines - lines);

                            // For mobile, we need to increase the bottom padding of the messages container because the message input is 'fixed' and not 'sticky'
                            if ($.isMobile()) {
                                var pb = parseInt(messagesContainer.css("padding-bottom"), 10);

                                // don't let padding go below 175 or messages will get cut off behind the message input area
                                var newPb = (pb + pixelsToScroll) >= 175 ? (pb + pixelsToScroll) : 175;
                                messagesContainer.css("padding-bottom", newPb);
                            }

                            // Scroll the detail up or down the number of pixels the text box height changed
                            detail.scrollTop(scrollPostion + pixelsToScroll);

                            // update lines variable
                            lines = currentLines;
                        }
                    }

                    // show spinner when send button is clicked
                    sendButton.on("click", function () {

                        // Don't show the spinner if there are errors
                        var isValid = form.validate().form();
                        if (isValid) {
                            $(this).addClass(cssClasses.executing);
                        }
                    });

                    // Scroll file upload to the bottom when new files are added
                    // Doing this on start and complete as files can change length as they are staged
                    // this affects the scroll height and we need to adjust as they complete/resize
                    fileUpload.onFileUploadStarted(scrollFileUploadToBottom);
                    fileUpload.onFileUploadComplete(scrollFileUploadToBottom);

                    function scrollFileUploadToBottom() {
                        let fileContainer = fileUpload.fileUploadControl.find('[data-js="_files"]');
                        fileContainer.scrollTop(fileContainer[0].scrollHeight);
                    }
                }
            })();
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);